export default __webpack_public_path__ + "static/media/lightmode@2x.3fb6f7ca.png";